export default "__VITE_ASSET__27c745bf__"